import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import { useToasts } from "react-toast-notifications";

const useVendorBankDetails = (vendorId) => {
  const dispatch = useDispatch();
  const {addToast} = useToasts();
  const [banks, setBanks] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [vendor, setVendor] = useState("");
  const fetchVendorBankDetails = async () => {
    try {
      const res = await dispatch(fetchAsyncGetVendorByID(vendorId));
      if (res?.payload) {
        const vendor = res.payload?.vendor;
        const bankDetails = vendor?.bnkDtl || [];

        const options = bankDetails.map((bank) => ({
          label: `${bank?.bnk} - ${bank.acNo.slice(-4)}`,
          value: bank._id,
        }));
        setVendor(vendor);
        setBankOptions(options);
        setBanks(bankDetails);
      }
    } catch (error) {
      addToast(`Error fetching vendor details: ${error.message}`, {
        appearance: "error",
      });
    }
  };

  useEffect(() => {
    if (vendorId) {
      fetchVendorBankDetails();
    }
  }, [vendorId]);

  return {
    vendor,
    banks,
    bankOptions,
  };
};

export default useVendorBankDetails;
